import { OrderType, SearchParams } from '../../../models';
import mapper from '../../../views/CallCenter/mappers';
import services from '../../../services';
import types from './types';

const { CallCenterService } = services;

const setPagination = (state: any, payload: any) => {
  state.storeTable.pagination = payload;
};

const setPaginationTotalItems = (state: any, payload: any) => {
  state.storeTable.pagination.totalItems = payload;
};

const setPaginationRowPerPage = (state: any, payload: any) => {
  state.storeTable.pagination.rowsPerPage = payload;
};

const setItems = (state: any, payload: any) => {
  state.storeTable.items = payload;
};

const setLoader = (state: any, payload: any) => {
  state.storeTable.loading = payload;
};

const queryItems = (state: any, payload: SearchParams) => {
  const { sortBy, order, totalItems } = state.storeTable.pagination;
  let items;
  state.storeTable.loading = true;

  CallCenterService.getCallCenterCustomer(payload).then(result => {
    const dataMapped = mapper.mapCustomerDtoListToSearchCustomerVmList(result.data.customers);
    items = dataMapped;

    if (sortBy) {
      items.sort((a, b) => {
        const sortA = a[sortBy];
        const sortB = b[sortBy];

        if (order === OrderType.DESC) {
          if (sortA < sortB) return 1;
          if (sortA > sortB) return -1;
          return 0;
        }
        if (sortA < sortB) return -1;
        if (sortA > sortB) return 1;
        return 0;
      });
    }

    state.storeTable.items = items;
    state.storeTable.pagination.totalItems = totalItems;
    state.storeTable.loading = false;
  });
};

export default {
  [types.SET_PAGINATION]: setPagination,
  [types.SET_PAGINATION_ROW_PER_PAGE]: setPaginationRowPerPage,
  [types.SET_PAGINATION_TOTAL_ITEMS]: setPaginationTotalItems,
  [types.SET_ITEMS]: setItems,
  [types.QUERY_ITEMS]: queryItems,
  [types.SET_LOADER]: setLoader,
};